<template>
  <div class="line-wrapper">
    <div ref="line" class="pie"></div>
  </div>
</template>

<script>
export default {
  name: 'sheet-line',
  props: {
    // "0":"全部" "1": "充电", "2": "清洁", "4": "教学", "5": "自动", "8": "开机"
    lineType: {
      type: String,
      default: '0'
    },
    lineData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      lineProps: []
    };
  },
  watch: {
    lineData() {
      this.drawLine();
    },
    lineType() {
      this.drawLine();
    }
  },
  mounted: function () {
    this.drawLine();
  },
  methods: {
    initProps() {
      // "0":"全部" "1": "充电", "2": "清洁", "4": "教学", "5": "自动"
      if (this.lineType === '0') {
        this.lineProps = [
          {
            name: this.$t('line.qing_jie_mian_jio', [this.$formatLenUnit()]),
            code: 'totalCleanArea',
            color: '#00A0D9',
            type: 'bar'
          },
          {
            name: this.$t('line.qjscmin'),
            // icon: 'rect',
            code: 'totalUsageTime',
            color: '#93DA49',
            type: 'line'
          },
        ];
      } else if (this.lineType === '2') {
        this.lineProps = [
          {
            name: this.$t('line.qing_jie_mian_jio', [this.$formatLenUnit()]),
            code: 'manualCleanArea',
            color: '#00A0D9',
            type: 'bar'
          },
          {
            name: this.$t('line.qjscmin'),
            code: 'manualUsageTime',
            color: '#93DA49',
            type: 'line'
          }
        ];
      } else if (this.lineType === '5') {
        this.lineProps = [
          {
            name: this.$t('line.qing_jie_mian_jio', [this.$formatLenUnit()]),
            code: 'autonomousCleanArea',
            color: '#00A0D9',
            type: 'bar'
          },
          {
            name: this.$t('line.qjscmin'),
            code: 'autonomousUsageTime',
            color: '#93DA49',
            type: 'line'
          }
        ];
      } else if (this.lineType === '4') {
        this.lineProps = [
          {
            name: this.$t('line.qing_jie_mian_jio', [this.$formatLenUnit()]),
            code: 'trainingCleanArea',
            color: '#00A0D9',
            type: 'bar'
          },
          {
            name: this.$t('line.qjscmin'),
            code: 'trainingUsageTime',
            color: '#93DA49',
            type: 'line'
          }
        ];
      } else if (this.lineType === '1') {
        this.lineProps = [
          {
            name: this.$t('line.cdscmin'),
            code: 'chargingTime',
            color: '#93DA49',
            type: 'line'
          }
        ];
      } else if (this.lineType === '8') {
        this.lineProps = [
          {
            name: this.$t('line.kai_ji_shi_changmin'),
            code: 'bootTime',
            color: '#93DA49',
            type: 'line'
          }
        ];
      }
    },

    drawLine() {
      this.initProps();
      if (this.myChart) {
        this.myChart.dispose();
      }
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(this.$refs.line);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
      // 绘制图表
      this.myChart.setOption({
        // tooltip: {
        //   show: true
        // },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        grid: {
          left: 50,
          right: 50,
          bottom: 100, // y2表示dataZoom与X轴的距离
        },
        legend: {

          top: this.lineData.length <= 12 ? undefined : 0,
          left: 'center',
          bottom: this.lineData.length <= 12 ? 0 : undefined,
          // right: 0,
          itemGap: 18,
          padding: 20,
          data: this.lineProps.map(t => ({
            name: t.name,
            icon: t.icon || undefined,

            textStyle: {
              color: t.color,
              fontWeight: 'bold',

              fontSize: 12
            },
            itemStyle: {
              color: t.color || undefined
            }
          }))
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          axisLine: {
            show: true,
            lineStyle: { color: '#F0F0F0' }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            margin: 10,
            fontSize: 10,
            color: '#818181'
          },
          data: this.lineData.map(t => t.reportDate)
        },
        yAxis: this.lineProps.map((t, i) => (
          {
            type: 'value',
            scale: true,
            // splitNumber: 6,
            name: t.name,
            position: i === 0 ? 'left' : 'right',
            // offset: i === 0 ? 0 : 80,
            nameGap: 24,
            // nameLocation: 'start',
            nameTruncate: {
              maxWidth: 90,
              ellipsis: '...'
            },
            nameTextStyle: {
              color: t.color,
              lineHeight: 32,
              fontWeight: 'bold',
              // align: i === 0 ? 'left' : 'right',
              padding: i === 0 ? 0 : [0, 0, 0, 20]
            },
            axisLine: {
              show: true,
              lineStyle: { color: '#F0F0F0' }
            },
            axisLabel: {
              margin: 10,
              fontSize: 10,
              color: '#818181'
            },
            splitLine: {
              show: i === 0,
              lineStyle: { color: '#F0F0F0' }
            },
            min: 0
          }
        )),
        dataZoom: this.lineData.length <= 12 ? null : [
          {
            type: 'slider',
            start: 100 - parseInt(1200 / this.lineData.length, 10),
            end: 100, // 以12为一份
            height: '15px', // 高度设置，另外还有宽度
            width: '100%'
          }
        ],
        series: this.lineProps.map((t, i) => ({
          name: t.name,
          data: this.lineData.map(f => f[t.code]),
          // barWidth: '30%',
          type: t.type,
          yAxisIndex: i,
          lineStyle: {
            color: t.color,
            with: 3
          },
          symbolSize: 8,
          symbol: 'circle',
          legendHoverLink: false,
          itemStyle: {
            color: t.color,
            borderColor: '#ffffff',

            borderType: 'solid'
          }
        }
        ))


        // series: [
        //   {
        //     name: '清洁面积',
        //     data: [120, 332, 901, 934, 1290, 3300, 1320, 1120, 332, 901, 934, 590, 1330],
        //     type: 'line',

        //     lineStyle: {
        //       color: '#00A0D9',
        //       with: 3
        //     },
        //     symbolSize: 8,
        //     symbol: 'circle',
        //     legendHoverLink: false,
        //     itemStyle: {
        //       color: '#00A0D9',
        //       borderColor: '#ffffff',
        //       borderWidth: 2,
        //       borderType: 'solid'
        //     }
        //   },
        //   {
        //     name: '清洁时长',
        //     data: [332, 901, 934, 590, 1330, 120, 332, 901, 934, 1290, 3300, 1320, 1120],
        //     type: 'line',
        //     // smooth: true,
        //     yAxisIndex: 1,
        //     lineStyle: {
        //       color: '#93DA49',
        //       with: 3
        //     },
        //     symbolSize: 8,
        //     symbol: 'circle',
        //     legendHoverLink: false,
        //     itemStyle: {
        //       color: '#93DA49',
        //       borderColor: '#ffffff',
        //       borderWidth: 2,
        //       borderType: 'solid'
        //     }
        //   }
        // ]
      });
    },


  }
};
</script>

<style lang="scss">
.line-wrapper {
  height: 410px;
  position: relative;
  .pie {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }
}
</style>
